import { render, staticRenderFns } from "./OrgPermission.vue?vue&type=template&id=b75ff1e8&"
import script from "./OrgPermission.vue?vue&type=script&lang=js&"
export * from "./OrgPermission.vue?vue&type=script&lang=js&"
import style0 from "./OrgPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports